import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ComponentsGallery.css';

const ComponentsGallery = () => {
    const navigate = useNavigate();
    const products = Array.from({ length: 15 }, (_, i) => ({
        id: i + 1,
        image: `https://sakthivel.ascentbw.com/Files/Product/Pro${i + 1}.png`,
        title: `Precision Component ${i + 1}`,
        desc: "High-quality precision engineered component manufactured to meet stringent industry standards."
    }));

    // Double the items for infinite scroll effect
    const displayProducts = [...products, ...products];

    return (
        <section className="gallery">
            <div className="container">
                <div className="gallery-header">
                    <div className="gallery-header-left">
                        <h2 className="gallery-title">Components We Deliver</h2>
                    </div>
                    <div className="gallery-header-right">
                        <button
                            className="gallery-view-btn"
                            onClick={() => navigate('/products')}
                        >
                            VIEW ALL PRODUCTS
                        </button>
                        <p className="gallery-header-desc">
                            Explore our full range of precision engineered components,
                            manufactured to stringent quality standards for diverse industries.
                        </p>
                    </div>
                </div>
            </div>
            
            <div className="gallery-slider-wrapper">
                <div className="gallery-slider-track">
                    {displayProducts.map((product, index) => (
                        <div key={index} className="gallery-item">
                            <div className="gallery-img-box">
                                <img src={product.image} alt={product.title} title={product.title} />
                            </div>
                            <div className="gallery-info">
                                <h4 className="gallery-item-title">{product.title}</h4>
                                <p className="gallery-item-desc">{product.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ComponentsGallery;
